import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import useFetchProfile from "src/hooks/api/useFetchProfile";
import useQueryString from "src/hooks/useQueryString";
import { getCurrentDomainName } from "src/lib/domain";
import getTokenName from "src/lib/getTokenName";

export function createCookie() {
	let host = window.location.host;

	let domain = "";
	const currentDomainName = getCurrentDomainName();

	if (host.includes("demo.")) {
		domain = `demo.${currentDomainName}.nl`;
	} else if (process.env.NODE_ENV !== "development") {
		domain = `${currentDomainName}.nl`;
	} else if (process.env.NODE_ENV === "development") {
		domain = `${currentDomainName}.test`;
	}

	return {
		path: "/",
		maxAge: 2592000,
		domain,
	};
}

function useTokenListener() {
	const { token } = useQueryString();
	const navigate = useNavigate();
	const [, setCookie] = useCookies();
	const { fetchProfile } = useFetchProfile();

	useEffect(() => {
		if (token) {
			setCookie(getTokenName(), token.toString(), createCookie());
			localStorage.setItem(getTokenName(), token.toString());
			fetchProfile().then(() => {
				navigate("/dashboard");
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);
}

export default useTokenListener;
